module.exports = __webpack_public_path__ + "img/p67.b48ecbed.png";